import { isIOS } from '@/core/utils/deviceUtils';
import { getStoreDisplayName } from '../../utils/storeListUtils';
import type { PhysicalStoreVm } from '../viewModels/physicalStore.vm';

export type StoreClickBridgeData = {
  eventName: 'Store Clicked';
  storeId: string;
  cityName: string;
  storeName: string;
};

export type StoreClickBridgePayload = {
  storeBridgeData: StoreClickBridgeData;
};

export function buildStoreClickBridgeData(store: PhysicalStoreVm): StoreClickBridgeData {
  return {
    eventName: 'Store Clicked',
    storeId: String(store.id),
    cityName: store.cityName.trim(),
    storeName: getStoreDisplayName(store.storeName),
  };
}

export function serializeStoreClickBridgePayload(store: PhysicalStoreVm): {
  iosPayload: string;
  androidPayload: string;
  bridgeData: StoreClickBridgeData;
} {
  const bridgeData = buildStoreClickBridgeData(store);
  return {
    bridgeData,
    iosPayload: JSON.stringify(bridgeData),
    androidPayload: JSON.stringify({
      storeBridgeData: { ...bridgeData },
    }),
  };
}

/**
 * Mobile store list click in app webview (legacy `.address-list` parity).
 * iOS receives JSON event data; Android receives `{ storeBridgeData: {...} }`.
 */
export function postStoreClickToAppBridge(store: PhysicalStoreVm, catalogUrl: string): void {
  if (typeof window === 'undefined') return;

  const { iosPayload, androidPayload } = serializeStoreClickBridgePayload(store);

  if (isIOS()) {
    if (window.setDataForIOS) {
      window.setDataForIOS(iosPayload);
      return;
    }
  } else if (window.AndroidBridge?.setData) {
    window.AndroidBridge.setData(androidPayload);
    return;
  }

  window.location.href = catalogUrl;
}
